<template>
    <router-link
        v-if="target === '_self'"
        :to="href"
        :class="[classes, { active: isActive }]"
    >{{label}}</router-link>
    <a v-else :class="[classes, { active: isActive }]" :href="href" :target="target">{{label}}</a>
</template>

<script>
export default {
    name: "LinkComponent",
    props: {
        href: {
            type: String,
            required: true,
            default: '',
        },
        target: {
            type: String,
            required: false,
            default: '',
        },
        label: {
            type: String,
            required: true,
            default: '',
        },
        classes: {
            type: String,
            required: false,
            default: '',
        },
    },
    computed: {
        isActive() {
            return this.href === this.$route.path;
        }
    }
}
</script>